export const environment = {
  production: true
};



// WEBPACK FOOTER //
// C:/deployment/projects/bitcoin-chart/src/environments/environment.ts